<div class="dropdown">
  @if(showAlert && alertMessage !== '') {
  <p class="dropdown__alert-message">{{ alertMessage | translate }}</p>
  }
  <button [ngClass]="{'active': showOptions}" class="dropdown__toggle" aria-haspopup="true" (click)="showDropdown()">
    @if(placeHolder !== '') {
    <img src="./assets/images/icons/{{icon}}" alt="{{placeHolder}}" /> <span>{{placeHolder}}</span>
    } @else {
    <img src="./assets/images/icons/{{icon}}" alt="{{firstlabel}}" /> {{ firstlabel | translate }}
    }
  </button>

  @if (showOptions) {
  <ul [ngClass]="{'no-select-first-item': hasNoSelectFirstItem}" class="dropdown__menu" role="listbox"
    aria-expanded="false" (click)="onSelectedOption($event)">
    @for (option of options; track option.id) {
    <li [ngClass]="{'disabled': option.disabled, 'enabled': !option.disabled, 'selected': option.selected}"
      class="dropdown-option" [attr.data-disabled]="option.disabled" [attr.data-id]="option.id">
      {{option.label}}
    </li>
    }
  </ul>
  }
</div>
